// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item_font[data-v-229d24da]{font-size:14px}[data-size=\"2\"] .item_font[data-v-229d24da]{font-size:14px!important}[data-size=\"3\"] .item_font[data-v-229d24da]{font-size:16px!important}[data-size=\"4\"] .item_font[data-v-229d24da]{font-size:18px!important}.empty[data-v-229d24da]{width:100%;height:100%;margin:0 auto;display:flex;align-items:center;justify-content:center;position:relative}", ""]);
// Exports
module.exports = exports;
